import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from './serviceHelper'

export const customReportingViewsService = {
  getCustomReportingViewData: async (user) => {
    return (await axios.get(`${NODE_BASE_URL}/template/custom-view`, getAxiosOptions(user))).data
  },

  getCustomviewUserDetails: async (user) => {
    return (await axios.get(`${NODE_BASE_URL}/template/custom-view/user`, getAxiosOptions(user)))
      .data
  },
  saveCustomViewUSerDetails: async (user, payload) => {
    return await axios.post(
      `${NODE_BASE_URL}/template/custom-view/update-access`,
      payload,
      getAxiosOptions(user)
    )
  },
  getCustomHierarchyData: async (user, companyId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/reporting-views/${companyId}/custom-hierarchy-view`,
        getAxiosOptions(user)
      )
    ).data
  },
  getEmployeeOverViews: async (user, companyId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/reporting-views/${companyId}/custom-employee-overview`,
        getAxiosOptions(user)
      )
    ).data
  },
  getResourcePlanningListData: async (user, companyId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/reporting-views/${companyId}/custom-resourse-planning/get-list-data`,
        getAxiosOptions(user)
      )
    ).data
  },
  getResourcePlanningMetrices: async (user, companyId, department, year, designation) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/reporting-views/${companyId}/custom-resourse-planning/get-metrics/${department}/${year}/${designation}`,
        getAxiosOptions(user)
      )
    ).data
  },
  getSnaggingDesnaggingListData: async (user, companyId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/reporting-views/${companyId}/custom-snaggingandesnagging-view/get-list-data`,
        getAxiosOptions(user)
      )
    ).data
  },

  getFlatHandingOverListData: async (user, companyId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/reporting-views/${companyId}/custom-flathandingover-view/get-list-data`,
        getAxiosOptions(user)
      )
    ).data
  },

  getQualityInspectionReportListData: async (user, companyId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/reporting-views/${companyId}/custom-qualityinspection-view/get-list-data`,
        getAxiosOptions(user)
      )
    ).data
  },

  getPreviewTimelineFlowProcesses: async (user, process_reference_num, process_template_id) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/preview-timeline-flow/${process_reference_num}/${process_template_id}`,
        getAxiosOptions(user)
      )
    ).data
  },

  getSnaggingDesnaggingDashboard: async (user, companyId, project, tower, floor, unit) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/reporting-views/${companyId}/custom-snaggingandesnagging-view/get-snagg-desnagg-data?project=${project}&&tower=${tower}&&floor=${floor}&&unit=${unit}`,
        getAxiosOptions(user)
      )
    ).data
  },
  getFlatHandingOverDashboard: async (user, companyId, project, tower, floor, unit) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/reporting-views/${companyId}/custom-flathandingover-view/get-flathandingover-data?project=${project}&&tower=${tower}&&floor=${floor}&&unit=${unit}`,
        getAxiosOptions(user)
      )
    ).data
  },
  getQualityInspectionReportDashboard: async (
    user,
    companyId,
    project,
    tower,
    floor,
    unit,
    pkg
  ) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/reporting-views/${companyId}/custom-qualityinspection-view/get-quality-inspection-data?project=${project}&&tower=${tower}&&floor=${floor}&&unit=${unit}&&package=${pkg}`,
        getAxiosOptions(user)
      )
    ).data
  },

  getComplianceReportData: async (user, companyId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/reporting-views/${companyId}/custom-compliance-report-view/get-compliance`,
        getAxiosOptions(user)
      )
    ).data
  },

  getAMComplianceReportData: async (user, companyId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/reporting-views/${companyId}/am-custom-compliance-report-view/get-compliance`,
        getAxiosOptions(user)
      )
    ).data
  },

  getListData: async (user, companyId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/reporting-views/${companyId}/custom-compliance-report-view/get-list-data`,
        getAxiosOptions(user)
      )
    ).data
  },

  getDMSlistData: async (user, companyId, id) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/reporting-views/${companyId}/custom-dms/get-list-data`,
        getAxiosOptions(user)
      )
    ).data
  },

  getAMlistData: async (user, companyId, id) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/reporting-views/${companyId}/am-module-view/get-am-budget-tracker-list-data`,
        getAxiosOptions(user)
      )
    ).data
  },

  getAMBudgetTrackerData: async (user, companyId, payload) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/reporting-views/${companyId}/am-module-view/get-am-budget-tracker-data`,
        payload,
        getAxiosOptions(user)
      )
    ).data
  },

  createDmsProcess: async (user, companyId, payload) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/reporting-views/${companyId}/custom-dms/create-process`,
        payload,
        getAxiosOptions(user)
      )
    ).data
  },

  getDmsProcess: async (
    user,
    companyId,
    processTemplateId,
    projectId,
    packageId,
    selectedDepartmentId,
    selectedCategoryId
  ) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/reporting-views/${companyId}/custom-dms/${processTemplateId}/${projectId}/${selectedDepartmentId}/${selectedCategoryId}/${packageId}`,
        getAxiosOptions(user)
      )
    ).data
  },

  addProcessTemplateData: async (user, companyId, payload) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/reporting-views/${companyId}/custom-dms/add-process-template-map`,
        payload,
        getAxiosOptions(user)
      )
    ).data
  },

  deleteProcessTemplateData: async (user, companyId, payload) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/reporting-views/${companyId}/custom-dms/delete-process-template-map`,
        payload,
        getAxiosOptions(user)
      )
    ).data
  },
  addFieldMapping: async (user, companyId, payload) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/reporting-views/${companyId}/custom-dms/add-field-map`,
        payload,
        getAxiosOptions(user)
      )
    ).data
  },

  saveProcessData: async (user, companyId, processDataId, processDataValue, modifiedByID) => {
    const values = { ...processDataValue }
    delete values['updatedAt']

    if (!values || Object.keys(values).length === 0) {
      console.warn('No values to update')
      return
    }

    try {
      const res = await axios.put(
        `${NODE_BASE_URL}/reporting-views/${companyId}/custom-dms/${processDataId}`,
        {
          data: values,
          modifiedBy: modifiedByID,
        },
        getAxiosOptions(user)
      )

      return res.data
    } catch (err) {
      console.error('Error in saveProcessData:', err)
      throw err
    }
  },
}
